import React from "react";
import Banner from "../components/common/banner";
import HowItWorks from "../components/common/how-it-works";
import Reviews from "../components/common/reviews";
import ServicesSection from "../components/common/section-card";
import DownloadSection from "../components/common/download-section";

const LandingPage = () => {
  return (
    <div className="bg-gray-50">
      <Banner />
      <ServicesSection />
      <DownloadSection />
      <HowItWorks />
      <Reviews />
    </div>
  );
};

export default LandingPage;
